<template>
    <div class="col-12 col-lg-8 order-lg-1">
        <notification-alert-block v-for="(notification, key) in preparedNotifications" :notification="notification"
                                  :setnotificationlink="setnotificationlink" :key="key"></notification-alert-block>

        <template v-if="ordertype === 'stopped'">
            <ukraine-stopped-order
                                     :lng="lng"
                                     :mainlng="mainlng"
                                     :translations="translations"
                                     :parcel="parcel"
                                     :orders="orders"
                                     :paymentmethods="paymentmethods"
                                     :deliverymethods="deliverymethods"
                                     :ordertype="ordertype"
                                     :account="account"
                                     :locations="locations"
                                     :savedeliverylink="savedeliverylink"
                                     :dopaymentlink="dopaymentlink"
                                     :neworderslink="neworderslink"
                                     :ordersonwarehoselink="ordersonwarehoselink"
                                     :sentorderslink="sentorderslink"
                                     :arrivedorderslink="arrivedorderslink"
                                     :deliveredorderslink="deliveredorderslink"
                                     :setnotificationlink="setnotificationlink"
                                     :upload_files_link="upload_files_link"
                                     :delete_files_link="delete_files_link"
                                     :downloadlink="downloadlink"
                                     :refusebilllink="refusebilllink"
                                     :confirmorderlink="confirmorderlink"
            ></ukraine-stopped-order>
        </template>
        <template v-else>
            <new-to-on-warehouse-order v-if="['new','on-warehouse'].includes(ordertype)"
                                       :lng="lng"
                                       mainlng="mainlng"
                                       :translations="translations"
                                       :parcel="parcel"
                                       :ordertype="ordertype"
                                       :neworderslink="neworderslink"
                                       :ordersonwarehoselink="ordersonwarehoselink"
                                       :sentorderslink="sentorderslink"
                                       :arrivedorderslink="arrivedorderslink"
                                       :deliveredorderslink="deliveredorderslink"
                                       :upload_files_link="upload_files_link"
                                       :delete_files_link="delete_files_link"
                                       :downloadlink="downloadlink"
                                       :locations="locations"
                                       :setnotificationlink="setnotificationlink"
            ></new-to-on-warehouse-order>
            <sent-to-delivered-order v-if="['sent','arrived', 'delivered'].includes(ordertype)"
                                     :lng="lng"
                                     :mainlng="mainlng"
                                     :translations="translations"
                                     :parcel="parcel"
                                     :orders="orders"
                                     :paymentmethods="paymentmethods"
                                     :deliverymethods="deliverymethods"
                                     :ordertype="ordertype"
                                     :account="account"
                                     :locations="locations"
                                     :savedeliverylink="savedeliverylink"
                                     :dopaymentlink="dopaymentlink"
                                     :neworderslink="neworderslink"
                                     :ordersonwarehoselink="ordersonwarehoselink"
                                     :sentorderslink="sentorderslink"
                                     :arrivedorderslink="arrivedorderslink"
                                     :deliveredorderslink="deliveredorderslink"
                                     :setnotificationlink="setnotificationlink"
                                     :upload_files_link="upload_files_link"
                                     :delete_files_link="delete_files_link"
                                     :downloadlink="downloadlink"
                                     :refusebilllink="refusebilllink"
                                     :confirmorderlink="confirmorderlink"
                                     :presavedeliverylink="presavedeliverylink"
                                     :novaposhtacitysearchlink="novaposhtacitysearchlink"
                                     :novaposhtastreetsearchlink="novaposhtastreetsearchlink"
                                     :novaposhtawarehousessearchlink="novaposhtawarehousessearchlink"
            ></sent-to-delivered-order>
        </template>
    </div>
</template>

<script>
export default {
    name: "ViewOrderContainer",
    props: {
        translations: {
            type: [Object, Array]
        },
        orders: {
            type: [Object, Array],
            default: () => []
        },
        paymentmethods: {
            type: [Object, Array],
            default: []
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        parcel: {
            type: [Object],
            default: null
        },
        ordertype: {
            required: true,
            type: [String]
        },
        deliverymethods: {
            type: [Object, Array],
            default: () => []
        },
        account: {
            type: [Object, Array],
            default: () => []
        },
        locations: {
            type: [Object, Array]
        },
        savedeliverylink: {
            type: [String]
        },
        dopaymentlink: {
            type: [String],
            default: null
        },
        neworderslink: {
            type: [String],
            default: null
        },
        ordersonwarehoselink: {
            type: [String],
            default: null
        },
        sentorderslink: {
            type: [String],
            default: null
        },
        arrivedorderslink: {
            type: [String],
            default: null
        },
        deliveredorderslink: {
            type: [String],
            default: null
        },
        upload_files_link: {
            type: [String]
        },
        delete_files_link: {
            type: [String],
            default: null
        },
        downloadlink: {
            type: [String],
            default: null
        },
        setnotificationlink: {
            type: [String],
            default: null
        },
        refusebilllink: {
            type: [Array],
            default: null
        },
        confirmorderlink: {
            type: [String],
            default: null
        },
        presavedeliverylink: {
            type: [String]
        },
        novaposhtacitysearchlink: {
            type: [String]
        },
        novaposhtastreetsearchlink: {
            type: [String]
        },
        novaposhtawarehousessearchlink: {
            type: [String]
        }
    },
    computed: {
        preparedNotifications() {
            if (typeof this.account.notifications === 'undefined' || this.account.notifications === null) {
                return []
            }
            return this.account.notifications;
        }
    }

}
</script>
<style scoped>

</style>
